'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DEVICE_DESKTOP = exports.DEVICE_TABLET = exports.DEVICE_PHONE = undefined;

var _mobileDetect = require('mobile-detect');

var _mobileDetect2 = _interopRequireDefault(_mobileDetect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEVICE_PHONE = exports.DEVICE_PHONE = 'Mobile';
var DEVICE_TABLET = exports.DEVICE_TABLET = 'Tablet';
var DEVICE_DESKTOP = exports.DEVICE_DESKTOP = 'Desktop';

function getDeviceType() {
    var mobileDetect = new _mobileDetect2.default(window.navigator.userAgent);

    if (mobileDetect.phone()) {
        return DEVICE_PHONE;
    }

    if (mobileDetect.tablet() || window.navigator.maxTouchPoints > 1) {
        return DEVICE_TABLET;
    }

    return DEVICE_DESKTOP;
}

exports.default = getDeviceType;


//////////////////
// WEBPACK FOOTER
// ./~/rp-prices-component/~/rp-analytics/lib/utils/getDeviceType.js
// module id = 431
// module chunks = 1